<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
  <!--MAIN-->
  <div class="m-content">
    <!--begin::Portlet-->
    <form
        [formGroup]="form"
        *ngIf="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!merchantId">
              ONLINE SALES WEBSITE
            </h3>
          </div>
        </div>
      </div>

      <!--begin::Form-->
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Website Host Name:
                <span [hidden]="formControls('name').value" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="name"
                  type="text"
                  id="name"
                  [ignoreWhiteSpace]
                  class="form-control m-input"
                  placeholder=""
                  (input)="checkHostnameAvailability()"
                  (blur)="generateBaseQRCode()"    
                />
                <i *ngIf="availableHostname && formControls('name').value !== ''" class="tooltip-icon accepted-icon note-icon-menu-check" tooltip="That hostname is available"></i>
                <i *ngIf="!availableHostname && formControls('name').value !== ''" class="tooltip-icon danger-icon flaticon-exclamation-2" tooltip="That hostname is already taken."></i>
                <span *ngIf="form.controls.name.value && form.controls.name.value != ''" style="font-weight: 800;" class="m-form__help">
                    https://{{form.controls.name.value + environment}}cue5050.com
                </span>
                <app-validation-display
                  [control]="form.controls.name"
                  errorMessage="Please provide a valid website host name. The name must not contain upper case letters or special characters other than '-' or '.'"
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Primary Color:
                <span [hidden]="formControls('primaryColor').value.length" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-2">
                <input
                  formControlName="primaryColor"
                  type="text"
                  class="form-control m-input"
                  [colorPicker]="formControls('primaryColor').value"
                  [cpDisableInput]="true"
                  [cpPosition]="right"
                  [cpAlphaChannel]="'disabled'"
                  [value]="formControls('primaryColor').value"
                  [style.background]="formControls('primaryColor').value"
                  (colorPickerChange)="formControls('primaryColor').setValue($event)"
                />
                <app-validation-display [control]="form.controls.primaryColor" errorMessage="Please specify valid color"></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Secondary Color:
                <span [hidden]="formControls('secondaryColor').value.length" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-2">
                <input
                  formControlName="secondaryColor"
                  type="text"
                  class="form-control m-input"
                  [colorPicker]="formControls('secondaryColor').value"
                  [cpDisableInput]="true"
                  [cpPosition]="right"
                  [cpAlphaChannel]="'disabled'"
                  [value]="formControls('secondaryColor').value"
                  [style.background]="formControls('secondaryColor').value"
                  (colorPickerChange)="formControls('secondaryColor').setValue($event)"
                />
                <app-validation-display [control]="form.controls.secondaryColor" errorMessage="Please specify valid color"></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Legal PDF:
                <span [hidden]="!formControls('legalUrl').value.length" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-4" style="display: flex;">
                <div style="display: flex; flex-direction: column;">
                  <input
                      type="file"
                      (change)="savePdf($event.target.files[0])"
                      name="file-1[]"
                      id="file-1"
                      class="venue-fileinput"
                      accept="application/pdf"
                    />
                  <a
                    *ngIf="formControls('legalUrl').value !== ''"
                    alt="" [href]="formControls('legalUrl').value"
                    style="display: block;"
                    target="_blank">
                    Legal Specifications
                  </a>
                  <span
                    onselectstart="return false"
                    class="img-text"
                    style="display: block;">
                      Click here to upload a PDF of legal specifications
                  </span>
                  <app-validation-display
                    *ngIf="formControls('legalUrl')?.errors?.required === true"
                    [control]="formControls('legalUrl')"
                    errorMessage="This file is required.">
                  </app-validation-display>
                  <app-validation-display
                    *ngIf="formControls('legalUrl')?.errors?.notPdf === true"
                    [control]="formControls('legalUrl')"
                    errorMessage="Make sure the file is a PDF.">
                  </app-validation-display>
                </div>
                <a *ngIf="formControls('legalUrl').value !== ''" (click)="deletePdf()" href="#" class="m-menu__link" style="display: inline; text-decoration: none; margin-top: 5px; position: relative; left: 8px;">
                  <i class="m-menu__link-icon flaticon-cancel"></i>
                </a>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Banner Image:
                <span [hidden]="!formControls('bannerUrl').value.length" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'banner')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/*"
                  />
                <img
                  *ngIf="formControls('bannerUrl').value !== ''"
                  alt="" [src]="formControls('bannerUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your banner. Image must have a minimum width of 1366px, minimum height of 768px, and an aspect ratio of 16:9.
                </span>
                <app-validation-display
                  *ngIf="formControls('bannerUrl')?.errors?.required === true"
                  [control]="formControls('bannerUrl')"
                  errorMessage="This file is required.">
                </app-validation-display>
                <app-validation-display
                  *ngIf="formControls('bannerUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('bannerUrl')"
                  errorMessage="Make sure your file is an image, has a height greater than or equal to 768px, a width greater than or equal to 1366, and an aspect ratio of 16:9.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Logo Image:
                <span [hidden]="!formControls('logoUrl').value.length" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'logo')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/png"
                  />
                <img
                  *ngIf="formControls('logoUrl').value !== ''"
                  alt="" [src]="formControls('logoUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your logo. Image must be a PNG, have a minimum width of 60px, and minimum height of 44px.
                </span>
                <app-validation-display
                  *ngIf="formControls('logoUrl')?.errors?.required === true"
                  [control]="formControls('logoUrl')"
                  errorMessage="This file is required.">
                </app-validation-display>
                <app-validation-display
                  *ngIf="formControls('logoUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('logoUrl')"
                  errorMessage="Make sure your file is a PNG, has a height greater than or equal to 44px, and a width greater than or equal to 60px.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Sponsor Image:
              </label>
              <div class="col-lg-4">
                <input
                    type="file"
                    (change)="verifyImageDimensions($event.target.files[0], 'sponsor')"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/*"
                  />
                <img
                  *ngIf="formControls('sponsorUrl').value !== ''"
                  alt="" [src]="formControls('sponsorUrl').value" style="display: block;">
                <span
                  onselectstart="return false"
                  class="img-text"
                  style="display: block;"
                  >
                    Click here to upload an image of your Sponsor. Image must have a minimum width of 1380 px and a minimum height of 406px.
                </span>
                <app-validation-display
                  *ngIf="formControls('sponsorUrl')?.errors?.incorrectDimensions === true"
                  [control]="formControls('sponsorUrl')"
                  errorMessage="Make sure your file is an image, has a height greater than or equal to 406px, and a width greater than or equal to 1380px.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Sponsor Description:
              </label>
              <div class="col-lg-4">
                <textarea
                    formControlName="advertisementText"
                    class="form-control m-input"
                    rows="5"
                  ></textarea>
                <app-validation-display
                  [control]="formControls('advertisementText')"
                  errorMessage="Invalid text.">
                </app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Sponsor Url:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="advertisementUrl"
                  type="text"
                  [ignoreWhiteSpace]
                  class="form-control m-input"
                  placeholder=""
                  (blur)="validateUrl()"
                />
                <app-validation-display
                  [control]="formControls('advertisementUrl')"
                  errorMessage="Please provide a valid URL."
                ></app-validation-display>
              </div>
            </div>
            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
              FAQs:
                <span *ngif="(!formControls('faq').controls[0].controls.head.value || !formControls('faq').controls[0].controls.paragraph.value) && siteId==0" class="required-asterisk text-danger">1*</span>
                <span *ngIf="siteId!==0" [hidden]="validateFaq()" class="required-asterisk text-danger">*</span>
              </label>
              <div class="col-lg-4">
                <div
                  formArrayName="faq"
                  *ngFor="let t of formControls('faq').controls; let i = index"
                  >
                  <div *ngIf="t" [formGroupName]="i" class="faq" [ngStyle]="{'padding-top': i !== 0 ? '15px' : '0'}">
                    <div>
                      <input
                        formControlName="head"
                        type="text"
                        id="tierDescription"
                        class="form-control m-input"
                        placeholder="Question"
                        />
                      <textarea
                        formControlName="paragraph"
                        id="tierQuantity"
                        type=""
                        class="form-control m-input"
                        placeholder="Answer"
                      ></textarea>
                    </div>
                    <a *ngIf="i !== 0" (click)="deleteFaqItem(i)" href="#" class="m-menu__link faq-delete">
                      <i class="m-menu__link-icon flaticon-cancel"></i>
                    </a>
                </div>
                <app-validation-display
                  class="validation-display"
                  [control]="t.controls.head"
                  [errorMessage]="i === 0 ? 'At least one FAQ is required.' : 'Please enter a valid answer.'"
                  ></app-validation-display>
                <app-validation-display
                  class="validation-display"
                  [control]="t.controls.paragraph"
                  [errorMessage]="i === 0 ? 'At least one FAQ is required.' : 'Please enter a valid answer.'"
                  ></app-validation-display>
              </div>
            </div>
            </div>
            <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"></label>
            <div class="col-lg-3">
              <a (click)="newFaqItem()" style="text-decoration: none;" href="#">+ New Faq</a>
            </div>
            </div>
          </div>
        </div>
    </div>

    <div class="m-portlet" style="position: relative;">

      <ngx-spinner
        name="qrSpinner"
        [fullScreen]="false"
        bdColor="rgba(75, 55, 100, 0.5)"
        size="large"
        color="#fff"
        type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
      </ngx-spinner>

      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              Base Site QR Code
            </h3>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <div class="m-form__section m-form__section--first">
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
            </label>
            <div class="col-lg-4" style="display: flex; flex-direction: column; align-items: center;">
              <img
                *ngIf="form.get('baseQRUrl').value !== ''"
                tooltip='Right click, then click "save image as..." to download the QR code.'
                width="200"
                height="200"
                [src]="form.get('baseQRUrl').value"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              Ticket Tier QR Codes
            </h3>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <div class="m-form__section m-form__section--first">
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label"></label>
            <div  class="col-lg-3">
              <span class="m-form__help" style="font-weight: 800;">
              Create QR Codes
              </span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              QR Codes:
            </label>
            <div class="col-lg-4">
              <div
                formArrayName="qrCodes"
                *ngFor="let q of formControls('qrCodes').controls; let i = index"
                >
              <div *ngIf="q" [formGroupName]="i" style="display: flex; justify-content: start; flex-direction: column;" [ngStyle]="{'padding-top': i !== 0 ? '15px' : '0'}">
                <img
                  tooltip='Right click, then click "save image as..." to download the QR code.'
                  [src]="q.get('imageLink').value"
                  width="200"
                  height="200"/>
                <div
                  style="margin: 15px 0 0 0"
                  formGroupName="qrCodePricingTier"
                  >
                  <select
                    formControlName="cue5050Id"
                    class="col-lg-12 col-m-4 form-control m-input"
                    id="cue5050Id"
                    name="cue5050IdSelect"
                    (change)="onEventSelect(i)"
                    >
                    <option selected value="0">-- Select an Event --</option>
                    <option
                    *ngFor="let e of cue5050Site.currentEvents"
                    [selected]="e.cue5050Id === q.get('qrCodePricingTier.cue5050Id').value"
                    [value]="e.cue5050Id"
                    >
                    {{ e.event.name }}
                    </option>
                  </select>
                  <select
                    *ngIf="q.get('qrCodePricingTier.cue5050Id').value > 0"
                    formControlName="cue5050PricingTierId"
                    class="col-lg-12 col-m-4 form-control m-input"
                    id="cue5050PricingTierId"
                    name="cue5050PricingTierId"
                    (change)="onEventSelect(i)"
                    >
                    <option selected value="0">-- Select a Tier --</option>
                    <option
                    *ngFor="let t of getPricingTiers(q.get('qrCodePricingTier.cue5050Id').value)"
                    [selected]="t.cuePricingTierId === q.get('qrCodePricingTier.cue5050PricingTierId').value"
                    [value]="t.cue5050PricingTierId"
                    >
                    {{ t.description }}
                    </option>
                  </select>
                  <app-validation-display
                    [control]="q.get('qrCodePricingTier.cue5050PricingTierId')"
                    errorMessage="Please select a pricing tier."
                ></app-validation-display>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div class="form-group m-form__group row">
          <label class="col-lg-4 col-form-label"></label>
          <div class="col-lg-3">
            <a (click)="newQRCode()" style="text-decoration: none;" href="#">+ New QR Code</a>
          </div>
        </div>
      </div>
    </div> -->

</form>

    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button [disabled]="generatingQR" [debounceClick] type="submit" (click)="save()" class="btn btn-primary">
          {{ siteId > 0 ? 'Update' : 'Save' }}
        </button>
        <button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
          Cancel
        </button>
        <div *ngIf="hasValidationErrors">
          <span style="color:red">Please complete the required fields</span>
        </div>
      </div>
    </div>
  </div>
</div>
